<div class="message__confirm">
    <div class="grid-x grid-margin-x">
        <div class="cell large-12"><b>{{inputData.message}}</b><br><br></div>
        <div class="cell large-6">
            <button class="button button-primary" (click)="confirm()">Yes</button>
        </div>
        <div class="cell large-6">
            <button class="button button-alert" (click)="cancel()">No</button>
        </div>
    </div>
</div>